import React from "react";
import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { LayoutDashboard, Sparkles, Inbox, CalendarDays, Library, Wand2, Building2, Plug, Settings, PenSquare, FileText, Repeat } from "lucide-react";

const ITEMS = [
  { to: "/dashboard", label: "Go to Dashboard", icon: LayoutDashboard },
  { to: "/create", label: "Start a new Agent Run", icon: Sparkles },
  { to: "/manual-post", label: "Write a Manual Post", icon: PenSquare },
  { to: "/blog", label: "Open Blog Studio", icon: FileText },
  { to: "/repurpose", label: "Repurpose existing content", icon: Repeat },
  { to: "/inbox", label: "Open Content Inbox", icon: Inbox },
  { to: "/calendar", label: "View Calendar", icon: CalendarDays },
  { to: "/library", label: "Search Library", icon: Library },
  { to: "/skills", label: "Manage Skills", icon: Wand2 },
  { to: "/brands", label: "Edit Brands", icon: Building2 },
  { to: "/integrations", label: "Integrations", icon: Plug },
  { to: "/settings", label: "Settings", icon: Settings },
];

export function CommandPalette({ open, onOpenChange }) {
  const navigate = useNavigate();
  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Search workspace, jump to a page, or run a command…" data-testid="command-palette-input" />
      <CommandList>
        <CommandEmpty>No results.</CommandEmpty>
        <CommandGroup heading="Navigate">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <CommandItem
                key={it.to}
                value={it.label}
                onSelect={() => {
                  navigate(it.to);
                  onOpenChange?.(false);
                }}
              >
                <Icon className="h-3.5 w-3.5" />
                {it.label}
              </CommandItem>
            );
          })}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
